<form class="ticket" [formGroup]="formGroup">
    <div class="image-control"  *ngIf="!isKohker">
        <h3 *ngIf="index">{{ index }}</h3>
        <div class="visitor-image">
            <input accept="image/*" type="file" [id]="'photo-picker-' + filePickerKey + 'of-ticket' + fileTicketKey" #image hidden (input)="onPickPhoto($event)">
            <div
                class="image-wrapper"
                cdkOverlayOrigin
                #trigger="cdkOverlayOrigin"
                (mouseover)="openTooltip($event)"
                (mouseout)="closeTooltip($event)"
                (touchstart)="openTooltip($event)"
                (touchend)="closeTooltip($event, true)"
            >
                <div class="inprogress" *ngIf="isImageLoading; else imageLoaded">
                    <mat-spinner [diameter]="50" color="accent"></mat-spinner>
                </div>
                <ng-template #imageLoaded>
                    <img [ngClass]="{ 'user-image': true, error: photo.touched && photo.errors?.required }" [src]="imageSource || '/assets/img/default-pic.webp'" width="150" height="150">
                </ng-template>
            </div>
            <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="trigger"
                [cdkConnectedOverlayOpen]="isOpenTooltip"
            >
                <img width="150" class="tooltip" alt="tooltip" src="/assets/img/photo-tooltip.webp">
            </ng-template>
            <button mat-mini-fab color="accent" type="button" class="photo-picker" [matTooltip]="'LABEL.CHANGE_PHOTO' | translate" matTooltipClass="bg-accent">
                <label [for]="'photo-picker-' + filePickerKey + 'of-ticket' + fileTicketKey">
                    <mat-icon class="image-icon">perm_media</mat-icon>
                </label>
            </button>
        </div>
        <mat-error @fadeOpInOut *ngIf="photo.touched && photo.errors?.required">{{ 'MSG.PHOTO_REQUIRED' | translate }}</mat-error>
    </div>
    <div class="form-field">
        <!-- <div class="field flex-col lt">
            <label>{{ 'LABEL.GENDER' | translate }} *</label>
            <mat-form-field class="select-info" appearance="outline" color="accent" [ngClass]="{ error: gender.touched && gender.errors?.required }">
                <mat-select formControlName="sex">
                    <mat-option value="M">{{'GENDER.M' | translate }}</mat-option>
                    <mat-option value="F">{{'GENDER.F' | translate }}</mat-option>
                </mat-select>
                <mat-icon matPrefix svgIcon="gender"></mat-icon>
            </mat-form-field>
            <mat-error @fadeOpInOut *ngIf="gender.errors?.required && gender.touched ">{{'MSG.GENDER_REQUIRED' | translate}}</mat-error>
          </div>
          <div class="field flex-col lt">
              <label>{{ 'LABEL.GROUP_AGE' | translate }} *</label>
              <mat-form-field class="select-info" appearance="outline" color="accent" [ngClass]="{ error: groupAge.touched && groupAge.errors?.required }">
                  <mat-select formControlName="group_age">
                      <mat-option *ngFor="let group of groupAges" [value]="group._id">{{ group['group' + (currentLang == 'en' ? '' : '_kh')] }}</mat-option>
                  </mat-select>
                  <mat-icon matPrefix svgIcon="age"></mat-icon>
              </mat-form-field>
              <mat-error @fadeOpInOut *ngIf="groupAge.errors?.required && groupAge.touched">{{'LABEL.SELECT_GROUP_AGE' | translate}}</mat-error>
          </div>-->

        <div class="field flex-col lt">
          <h3>{{'LABEL.TICKET' | translate}} {{getFormattedTicketTitle()}}</h3>
        </div>
        <div class="field flex-col lt">
            <!-- <label>
              {{ 'LABEL.NATIONALITY' | translate }}
              <span class="required">*</span>
            </label> -->
            <mat-form-field class="select-info" appearance="outline" color="accent" [ngClass]="{ error: nationality.touched && nationality.errors?.required }">
                <mat-select formControlName="nationality" placeholder="{{'LABEL.NATIONALITY' | translate}}">
                    <mat-option class="search">
                        <ngx-mat-select-search  [formControl]="nationalityFilterCtrl"
                            [placeholderLabel]="'PUBLIC.SEARCH' | translate"
                            [noEntriesFoundLabel]="'MSG.NO_DATA' | translate">
                            <mat-icon ngxMatSelectSearchClear (click)="resetFilter()">clear</mat-icon>
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                        *ngFor="let nationality of filteredNationalityArray"
                        [value]="nationality?._id"
                    >
                        <!-- {{ ("NATIONALITIES." + (nationality?.nationality || 'UNKNOWN')) | translate }} -->
                          {{getNationalityName(nationality)}}
                    </mat-option>
                </mat-select>
                <mat-icon matPrefix svgIcon="flag"></mat-icon>
            </mat-form-field>
            <mat-error @fadeOpInOut *ngIf="nationality.errors?.required && nationality.touched">{{'LABEL.SELECT_NATIONALITY' | translate}}</mat-error>
        </div>
    </div>
    <!-- <div class="action">
        <button *ngIf="enableRemove" class="remove" type="button" mat-icon-button (click)="remove.emit()"><mat-icon color="warn">close</mat-icon></button>
    </div> -->
</form>
